import axios from 'axios';
import { BASE_URL } from '@/utils/constants';

const temp = axios.create({
	baseURL: BASE_URL,
	headers: {
		'accept-language': 'ar',
	},
});

temp.postput = (url, id, body, options) => {
	return id ? temp.put(url + '/' + id, body, options) : temp.post(url, body, options);
};

export default temp;
